import React from 'react';
import { useForm } from "react-hook-form";
import { TextField, FormControl, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Modal, Alert, Button } from "react-bootstrap";
import { ErrorMessage } from "@hookform/error-message";
import { toast } from "react-toastify";
import { axiosPrivate } from '../../../api/axios';
import { useNavigate } from "react-router-dom";

const ResetPass = () => {
	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const [showPassword1, setShowPassword1] = React.useState(false);
	const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const navigate = useNavigate();
	const {
		register: register1,
		watch,
		formState: { errors: errors1 },
		handleSubmit: handleSubmit1,
	} = useForm();

	const profileAPI = async (data) => {
		let url1;
		let profilePayload;
		url1 = "/user/reset-password"; profilePayload = { password: data?.new_password };
		try {
			await axiosPrivate.post(url1, profilePayload)
				.then((data) => {
					// console.log(data)
					if (data.data.success) {
						toast.success(data.data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
						navigate("/login");
					}
					else {
						toast.error(data.data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
						
					}
				})
				.catch((error) => {
					const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
					toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
					navigate("/login");
				})
		}
		catch (error) {
			navigate("/login");
		}
	}

	return (
		<>
			<Modal size="sm" show={true} style={{ background: "aliceblue" }} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header body-text-variant="--bs-purple">
					<Modal.Title id="contained-modal-title-vcenter">
						<div className="text-center">
							<h6>Set new password</h6>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={handleSubmit1(profileAPI)}>
						<div className="mybox">
							<div className="row">
								<div className="col text-center">
									<FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small" className="input-group mb-3">
										<TextField id="new_password" name="new_password" type={showPassword ? "text" : "password"} placeholder="Enter New Password Here" label="New Password"{...register1("new_password", {
											required: "This field is required"
										})}
											aria-invalid={errors1.new_password ? true : false} />
										<IconButton aria-label="toggle password visibility" className="position-absolute" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
										<ErrorMessage
											errors={errors1}
											name="new_password"
											render={({ message }) => (
												<Alert variant="danger" className="p-1 mb-0">
													{message}
												</Alert>
											)}
										/>
									</FormControl>
									<FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small" className="input-group mb-3">
										<TextField id="confirm_new_password" name="confirm_new_password" type={showPassword1 ? "text" : "password"} placeholder="Re-Enter New Password Here" label="Confirm New Password" {...register1("confirm_new_password", {
											required: "This field is required",
											validate: (value) => value === watch("new_password") || "The password do not match",
										})}
											aria-invalid={errors1.confirm_new_password ? true : false}
											sx={{
												".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": { height: "0.8em" },
												".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": { top: -5 }, '.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root': {
													padding: "10px 10px"
												}
											}} />
										<IconButton aria-label="toggle password visibility" className="position-absolute" onClick={handleClickShowPassword1} onMouseDown={handleMouseDownPassword} edge="end">
											{showPassword1 ? <Visibility /> : <VisibilityOff />}
										</IconButton>
										<ErrorMessage
											errors={errors1}
											name="confirm_new_password"
											render={({ message }) => (
												<Alert variant="danger" className="p-1 mb-0">
													{message}
												</Alert>
											)}
										/>
									</FormControl>
								</div>
								<div className="text-center mt-2">
									<Button variant="contained" className="btn btn-success btnc" type='submit'>
										Submit
									</Button>
									<Button variant="contained" className="btn btn-secondary btnc mx-3" type='button' onClick={() => navigate("/login")}>
										Logout
									</Button>
								</div>
							</div>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}
export default ResetPass;